// import React, { useEffect, useRef, useState } from "react";
// import Header from "./Header";
// import CurrentAffairsLandipageCards from "./CurrentAffairsLandipageCards";
// import Calender from "./calender";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import filterDatalist from "../services/getFilter";
// import "../CurrentAffairsLandipageCards.css";
// import {
//   fetchFilterData,
//   fetchCurrentAffairById,
// } from "../services/trendingService";
// import { getRelatedTopicsTen } from "../services/relatedTopicsService";

// function CurrentAffairsLandingPage({ Check, isSidebarColl }) {
//   // Initialize selectedCategory from localStorage or default to "All"
//   const getInitialSelectedCategory = () => {
//     const savedCategory = localStorage.getItem(
//       "currentAffairs_selectedCategory",
//     );
//     return savedCategory || "All";
//   };

//   const [selectedCategory, setSelectedCategory] = useState(
//     getInitialSelectedCategory,
//   );
//   const [calender, setCalender] = useState("all");

//   // Helper to get current month and year
//   const getCurrentYear = () => new Date().getFullYear();
//   const getCurrentMonth = () => {
//     const months = [
//       "january",
//       "february",
//       "march",
//       "april",
//       "may",
//       "june",
//       "july",
//       "august",
//       "september",
//       "october",
//       "november",
//       "december",
//     ];
//     return months[new Date().getMonth()];
//   };

//   // Load from localStorage or use current
//   const getInitialSelectedMonths = () => {
//     const saved = localStorage.getItem("currentAffairs_selectedMonths");
//     return saved !== null ? JSON.parse(saved) : [getCurrentMonth()];
//   };
//   const getInitialSelectedYears = () => {
//     const saved = localStorage.getItem("currentAffairs_selectedYears");
//     return saved !== null ? JSON.parse(saved) : [getCurrentYear()];
//   };
//   const [filter, setFilter] = useState("all");
//   const [selectedMonths, setSelectedMonths] = useState(
//     getInitialSelectedMonths,
//   );
//   const [skeltonloder, setSkeltonloader] = useState(false);
//   const [selectedYears, setSelectedYears] = useState(getInitialSelectedYears);
//   const [currentAffairsData, setCurrentAffairsData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [currentSkip, setCurrentSkip] = useState(8);
//   const [loader, setLoader] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [data, setData] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [listData, setListData] = useState(true);
//   const [newloader, setnewloader] = useState(true);
//   const skipRef = useRef(0);
//   const scrollRef = useRef(null);
//   const [isApiCallinProgress, setIsApiCallinProgress] = useState(false);
//   const [noDataForCurrentFilter, setNoDataForCurrentFilter] = useState(false);
//   const [currentFilterKey, setCurrentFilterKey] = useState("");
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [filterLoading, setFilterLoading] = useState(false);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResults, setSearchResults] = useState(null);
//   const [isSearching, setIsSearching] = useState(false);

//   const handleChange = (e) => {
//     setFilterLoading(true);
//     setFilter(e.target.value);
//   };

//   // Debounce search
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       if (searchTerm.trim()) {
//         performSearch(searchTerm.trim());
//       } else {
//         setSearchResults(null);
//         setIsSearching(false);
//       }
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [searchTerm]);

//   const performSearch = async (term) => {
//     setIsSearching(true);
//     setSkeltonloader(true);
//     setListData(false);
//     try {
//       const response = await getRelatedTopicsTen([term]);
//       // Assuming response.matches or response.items contains the items
//       // based on typical API responses in this project
//       setSearchResults(response.matches || response.items || []);
//     } catch (error) {
//       console.error("Search failed:", error);
//       setSearchResults([]);
//     } finally {
//       setIsSearching(false);
//       setSkeltonloader(false);
//       setListData(true);
//     }
//   };

//   // Persist selection
//   useEffect(() => {
//     localStorage.setItem(
//       "currentAffairs_selectedMonths",
//       JSON.stringify(selectedMonths),
//     );
//   }, [selectedMonths]);

//   useEffect(() => {
//     localStorage.setItem(
//       "currentAffairs_selectedYears",
//       JSON.stringify(selectedYears),
//     );
//   }, [selectedYears]);

//   // Restore scroll position when data is loaded
//   useEffect(() => {
//     if (
//       currentAffairsData.length > 0 &&
//       currentFilterKey &&
//       scrollRef.current
//     ) {
//       const scrollKey = `currentAffairs_${currentFilterKey}_scroll`;
//       const savedScrollPosition = localStorage.getItem(scrollKey);
//       if (savedScrollPosition) {
//         // Use setTimeout to ensure DOM is fully rendered
//         setTimeout(() => {
//           if (scrollRef.current) {
//             scrollRef.current.scrollTop = parseInt(savedScrollPosition, 10);
//           }
//         }, 100);
//       }
//     }
//   }, [currentAffairsData.length, currentFilterKey]);

//   // Show skeleton immediately when filter changes (but don't clear data)
//   useEffect(() => {
//     if (!isInitialLoad) {
//       setnewloader(true);
//       setListData(false);
//       // Don't clear currentAffairsData - let the main useEffect handle it
//     }
//   }, [filter]);

//   // Clear filter loading state when data is loaded
//   useEffect(() => {
//     setFilterLoading(false);
//   }, [currentAffairsData]);

//   // Fetch filter categories on mount and set default active "All"
//   useEffect(() => {
//     setListData(false);
//     setnewloader(true);
//     const fetchData = async () => {
//       setnewloader(true);
//       const result = await filterDatalist.filterData();
//       setData(result);

//       // Find index of saved filter or "All" filter, default to 0 if not found
//       const savedCategory =
//         localStorage.getItem("currentAffairs_selectedCategory") || "All";
//       const savedIndex = result.findIndex(
//         (cat) => cat.name.toLowerCase() === savedCategory.toLowerCase(),
//       );
//       if (savedIndex !== -1) {
//         setActiveIndex(savedIndex);
//       } else {
//         const allIndex = result.findIndex(
//           (cat) => cat.name.toLowerCase() === "all",
//         );
//         if (allIndex !== -1) {
//           setActiveIndex(allIndex);
//         } else if (result.length > 0) {
//           setActiveIndex(0);
//         }
//       }
//     };
//     fetchData();
//   }, []);

//   // Infinite scroll listener with scroll position saving
//   useEffect(() => {
//     const div = scrollRef.current;
//     if (!div) return;

//     let timeoutId = null;
//     let scrollSaveTimeout = null;

//     const handleScroll = () => {
//       // Clear any pending timeout
//       if (timeoutId) {
//         clearTimeout(timeoutId);
//       }

//       // Save scroll position (debounced)
//       if (scrollSaveTimeout) {
//         clearTimeout(scrollSaveTimeout);
//       }
//       scrollSaveTimeout = setTimeout(() => {
//         if (currentFilterKey) {
//           const scrollKey = `currentAffairs_${currentFilterKey}_scroll`;
//           localStorage.setItem(scrollKey, div.scrollTop.toString());
//         }
//       }, 200); // 200ms debounce for saving scroll position

//       // Check for pagination (debounced)
//       timeoutId = setTimeout(() => {
//         if (
//           div.scrollTop + div.clientHeight + 80 >= div.scrollHeight &&
//           !loader &&
//           hasMore &&
//           !newloader &&
//           !isApiCallinProgress
//         ) {
//           setLoader(true);
//           setnewloader(true);
//           setPage((prevPage) => prevPage + 1);
//         }
//       }, 100); // 100ms debounce for pagination
//     };

//     div.addEventListener("scroll", handleScroll);
//     return () => {
//       div.removeEventListener("scroll", handleScroll);
//       if (timeoutId) {
//         clearTimeout(timeoutId);
//       }
//       if (scrollSaveTimeout) {
//         clearTimeout(scrollSaveTimeout);
//       }
//     };
//   }, [hasMore, currentFilterKey, loader, newloader, isApiCallinProgress]);

//   // Main data fetching effect
//   useEffect(() => {
//     let keywords =
//       selectedCategory === "All" ||
//       (Array.isArray(selectedCategory) && selectedCategory[0] === "All")
//         ? []
//         : Array.isArray(selectedCategory)
//           ? selectedCategory
//           : String(selectedCategory).split(/[\/&]/);

//     // Create a unique key for current filter combination including years, months, and filter
//     const yearsKey =
//       selectedYears.length > 0 ? selectedYears.sort().join("_") : "noYears";
//     const monthsKey =
//       selectedMonths.length > 0 ? selectedMonths.sort().join("_") : "noMonths";
//     const newFilterKey = `${keywords.join(
//       "_",
//     )}_${yearsKey}_${monthsKey}_${filter}`;

//     // Create a unique key for localStorage based on filters (including the filter dropdown)
//     const storageKey = `currentAffairs_${newFilterKey}`;
//     const pageStorageKey = `${storageKey}_page`;
//     console.log("Storage key being created:", storageKey);

//     // Load cached data from localStorage FIRST - always show cached data immediately
//     const cachedData = localStorage.getItem(storageKey);
//     const cachedPage = localStorage.getItem(pageStorageKey);

//     let existingData = [];
//     let loadedPage = 1;

//     if (cachedData) {
//       try {
//         existingData = JSON.parse(cachedData);
//         // Load the page number for this filter
//         if (cachedPage) {
//           loadedPage = parseInt(cachedPage, 10);
//         }
//       } catch (error) {
//         console.error("Error parsing cached data:", error);
//         // If parsing fails, remove invalid cache
//         localStorage.removeItem(storageKey);
//         localStorage.removeItem(pageStorageKey);
//         existingData = [];
//         loadedPage = 1;
//       }
//     }

//     // Check if filter changed - reset pagination if it did
//     if (newFilterKey !== currentFilterKey) {
//       setCurrentFilterKey(newFilterKey);

//       // Show cached data immediately for new filter
//       if (existingData.length > 0) {
//         setCurrentAffairsData(existingData);
//         setPage(loadedPage);
//         skipRef.current = existingData.length;
//         setNoDataForCurrentFilter(false);
//         setnewloader(false);
//         setListData(false);
//         setHasMore(true);

//         // Restore scroll position for this filter after data is rendered
//         setTimeout(() => {
//           const scrollKey = `currentAffairs_${newFilterKey}_scroll`;
//           const savedScrollPosition = localStorage.getItem(scrollKey);
//           if (savedScrollPosition && scrollRef.current) {
//             scrollRef.current.scrollTop = parseInt(savedScrollPosition, 10);
//           }
//         }, 0);

//         return; // Don't make API call, just show cached data
//       } else {
//         // No cached data, show skeleton and fetch from API
//         setCurrentAffairsData([]);
//         setPage(1);
//         skipRef.current = 0;
//         setNoDataForCurrentFilter(false);
//         setnewloader(true);
//         setListData(false);
//         setHasMore(true);

//         // Reset scroll position for new filter with no cache
//         if (scrollRef.current) {
//           scrollRef.current.scrollTop = 0;
//         }
//       }
//     }

//     // If we have cached data, show it first before making API call
//     if (existingData.length > 0 && currentAffairsData.length === 0) {
//       setCurrentAffairsData(existingData);
//       setListData(false);
//     }

//     // If we already know there's no data for this filter combination, don't make the API call
//     if (noDataForCurrentFilter && newFilterKey === currentFilterKey) {
//       setLoader(false);
//       setnewloader(false);
//       setListData(true);
//       return;
//     }

//     // Check if we should make an API call
//     // Only make API call if:
//     // 1. Not already in progress
//     // 2. We're on a new page OR it's a new filter with no cached data
//     const shouldMakeApiCall =
//       !isApiCallinProgress &&
//       (page > loadedPage || (page === 1 && existingData.length === 0));

//     if (!shouldMakeApiCall) {
//       setnewloader(false);
//       setLoader(false);
//       return;
//     }

//     // Get current date
//     let currentDate = new Date().toDateString();

//     // Make API call - show skeleton only at the bottom if we have existing data
//     if (existingData.length > 0) {
//       setLoader(true); // Show loader at bottom for pagination
//     } else {
//       setnewloader(true); // Show skeleton for initial load
//     }

//     setIsApiCallinProgress(true);
//     setSkeltonloader(true);
//     fetchFilterData(
//       skipRef.current,
//       filter,
//       keywords,
//       selectedYears,
//       selectedMonths,
//     )
//       .then((response) => {
//         console.log("response", response);
//         console.log(newloader, "newloader");
//         if (!response.items || response.items.length === 0) {
//           setListData(existingData.length === 0); // Only show "no data" if we have no cached data
//           setNoDataForCurrentFilter(existingData.length === 0);
//           setHasMore(false);
//         } else {
//           // Simply append new data without duplicate checking
//           const newData = [...existingData, ...response.items];

//           setCurrentAffairsData(newData);

//           // Update cache with the combined data
//           localStorage.setItem(storageKey, JSON.stringify(newData));
//           localStorage.setItem(`${storageKey}_date`, currentDate);

//           // Store the current page number (we've just loaded this page)
//           localStorage.setItem(pageStorageKey, page.toString());

//           skipRef.current = newData.length;
//           setCurrentSkip(newData.length);
//           setHasMore(response.items.length > 0);
//           setListData(false);
//         }
//       })
//       .catch((e) => {
//         console.error("API failed", e);
//         setHasMore(false);
//         setListData(existingData.length === 0);
//       })
//       .finally(() => {
//         setIsLoading(false);
//         setLoader(false);
//         setnewloader(false);
//         setIsApiCallinProgress(false);
//         setSkeltonloader(false);
//       });
//   }, [page, filter, selectedCategory, calender, selectedYears, selectedMonths]);

//   // ...existing code...

//   useEffect(() => {
//     localStorage.setItem(
//       "selectedCategory",
//       JSON.stringify(selectedCategory === "All" ? "" : selectedCategory),
//     );
//     localStorage.setItem("selectedYears", JSON.stringify(selectedYears));
//     localStorage.setItem("selectedMonths", JSON.stringify(selectedMonths));
//   }, [selectedCategory, selectedYears, selectedMonths]);

//   // When selectedCategory or calender changes, update activeIndex
//   useEffect(() => {
//     if (!isInitialLoad) {
//       // Don't reset page here - let the main useEffect handle filter changes
//       const newIndex = data.findIndex((cat) => cat.name === selectedCategory);
//       if (newIndex !== -1) {
//         setActiveIndex(newIndex);
//       }
//     } else {
//       setIsInitialLoad(false);
//     }
//   }, [
//     selectedCategory,
//     calender,
//     selectedYears,
//     selectedMonths,
//     data,
//     isInitialLoad,
//   ]);

//   const handleClick = (categoryName) => {
//     setSelectedCategory(categoryName);
//     // Save selected category to localStorage
//     localStorage.setItem("currentAffairs_selectedCategory", categoryName);
//   };

//   const filterDivRef = useRef();

//   const handleScrollleft = () => {
//     if (filterDivRef.current) {
//       filterDivRef.current.scrollBy({ left: 100, behavior: "smooth" });
//     }
//   };

//   const handleScrollright = () => {
//     if (filterDivRef.current) {
//       filterDivRef.current.scrollBy({ left: -100, behavior: "smooth" });
//     }
//   };

//   console.log("Current filter values:", {
//     selectedMonths,
//     selectedYears,
//     calender,
//     keywords:
//       selectedCategory === "All" ||
//       (Array.isArray(selectedCategory) && selectedCategory[0] === "All")
//         ? []
//         : Array.isArray(selectedCategory)
//           ? selectedCategory
//           : String(selectedCategory).split(/[\/&]/),
//   });

//   return (
//     <div className="main-div">
//       <div
//         className="syllabus-header-main"
//         style={
//           isSidebarColl
//             ? { left: 0, width: "100%" }
//             : { left: "240px", width: "calc(100% - 240px)" }
//         }
//       >
//         <Header
//           message={[{ message: "Current Affairs" }]}
//           Check={Check}
//           isSidebarColl={isSidebarColl}
//         />
//       </div>
//       {isLoading ? (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       ) : isLoading && currentAffairsData.length === 0 ? (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       ) : (
//         <div className="current-affairsdiv" ref={scrollRef}>
//           <div className="imgdiv">
//             <img
//               className="d-none d-md-block dekstop-img"
//               src="/assets/images/banner_currentaffairs.svg"
//               alt="star"
//             />
//             <img
//               className="d-block d-md-none custo"
//               src="/assets/images/mobile-view-landingpage.svg"
//               alt="star"
//             />
//           </div>

//           <div style={{ display: "flex" }} className="fil">
//             <div>
//               <button
//                 className="filter-button-arrow-right"
//                 onClick={handleScrollright}
//               >
//                 <img
//                   src="/assets/images/arrow2.svg"
//                   className="img-arrow"
//                   style={{ marginLeft: "0px" }}
//                 />
//               </button>
//             </div>

//             <div className="filter-div" ref={filterDivRef}>
//               {data.map((category, index) => (
//                 <button
//                   key={index}
//                   className={`filter-button ${
//                     activeIndex === index ? "active" : ""
//                   }`}
//                   onClick={() => {
//                     // prevent click when loading
//                     handleClick(category.name);
//                     setActiveIndex(index);
//                   }}
//                   disabled={newloader}
//                 >
//                   <img src={category.img} alt="icon" />
//                   <span className="filt-text">{category.name}</span>
//                 </button>
//               ))}
//             </div>

//             <div>
//               <button
//                 className="filter-button-arrow"
//                 onClick={handleScrollleft}
//               >
//                 <img
//                   src="/assets/images/arrow2.svg"
//                   className="img-arrow"
//                   style={{ marginLeft: "0px" }}
//                 />
//               </button>
//             </div>
//           </div>

//           <div className="heading-current-affairs">
//             <div
//               className="search-bar-container"
//               style={{ flex: 1, position: "relative" }}
//             >
//               <input
//                 type="text"
//                 className="search-input"
//                 placeholder="Search topics..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{
//                   width: "300px",
//                   padding: "8px 12px 8px 12px",
//                   borderRadius: "20px",
//                   border: "1px solid #e6e6e6",
//                   fontSize: "14px",
//                   outline: "none",
//                   backgroundColor: "#f9f9f9",
//                 }}
//               />
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 alignItems: "end",
//                 justifyItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <Calender
//                 setCalender={setCalender}
//                 calender={calender}
//                 setSelectedYears={setSelectedYears}
//                 setSelectedMonths={setSelectedMonths}
//                 selectedYears={selectedYears}
//                 selectedMonths={selectedMonths}
//                 newloader={newloader}
//               />
//               <div>
//                 <select
//                   className="filt-text"
//                   id="filter"
//                   value={filter}
//                   onChange={handleChange}
//                   disabled={newloader}
//                   style={{
//                     border: "1px solid #e6e6e6",
//                     padding: "10px",
//                     backgroundColor: newloader ? "#f5f5f5" : "#f0f0f0",
//                     width: "80px",
//                     height: "28px",
//                     padding: "5px",
//                     borderRadius: "4px",
//                     color: "#333",
//                     opacity: newloader ? 0.7 : 1,
//                   }}
//                 >
//                   <option className="filt-text" value="all">
//                     All
//                   </option>
//                   <option className="filt-text" value="read">
//                     Read
//                   </option>
//                   <option className="filt-text" value="unread">
//                     Unread
//                   </option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="parent-div">
//             {(searchTerm.trim() ? searchResults : currentAffairsData) &&
//               (searchTerm.trim() ? searchResults : currentAffairsData).map(
//                 (item, index) => (
//                   <CurrentAffairsLandipageCards
//                     key={index}
//                     news={item}
//                     setIsLoading={setIsLoading}
//                   />
//                 ),
//               )}

//             {/* Single skeleton loader only */}
//             {skeltonloder && (
//               <div style={{ marginBottom: "20px" }}>
//                 <Skeleton height={100} style={{ marginBottom: "15px" }} />
//                 <Skeleton height={40} style={{ marginBottom: "15px" }} />
//                 <Skeleton count={3} />
//               </div>
//             )}

//             {listData &&
//               !newloader &&
//               !loader &&
//               !isSearching &&
//               (searchTerm.trim()
//                 ? searchResults?.length === 0
//                 : currentAffairsData.length === 0) && (
//                 <div className="no-data">
//                   <img
//                     src="/assets/images/no-data-currentaffairs.png"
//                     className="no-data-img"
//                     width={40}
//                     height={40}
//                   />{" "}
//                   <h3>No Data Found</h3>
//                 </div>
//               )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CurrentAffairsLandingPage;



// import React, { useEffect, useRef, useState } from "react";
// import Header from "./Header";
// import CurrentAffairsLandipageCards from "./CurrentAffairsLandipageCards";
// import Calender from "./calender";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import filterDatalist from "../services/getFilter";
// import "../CurrentAffairsLandipageCards.css";
// import {
//   fetchFilterData,
//   fetchCurrentAffairById,
// } from "../services/trendingService";

// function CurrentAffairsLandingPage({ Check, isSidebarColl }) {
//   // Initialize selectedCategory from localStorage or default to "All"
//   const getInitialSelectedCategory = () => {
//     const savedCategory = localStorage.getItem(
//       "currentAffairs_selectedCategory"
//     );
//     return savedCategory || "All";
//   };

//   const [selectedCategory, setSelectedCategory] = useState(
//     getInitialSelectedCategory
//   );
//   const [calender, setCalender] = useState("all");

//   // Helper to get current month and year
//   const getCurrentYear = () => new Date().getFullYear();
//   const getCurrentMonth = () => {
//     const months = [
//       "january",
//       "february",
//       "march",
//       "april",
//       "may",
//       "june",
//       "july",
//       "august",
//       "september",
//       "october",
//       "november",
//       "december",
//     ];
//     return months[new Date().getMonth()];
//   };

//   // Load from localStorage or use current
//   const getInitialSelectedMonths = () => {
//     const saved = localStorage.getItem("currentAffairs_selectedMonths");
//     return saved !== null ? JSON.parse(saved) : [getCurrentMonth()];
//   };
//   const getInitialSelectedYears = () => {
//     const saved = localStorage.getItem("currentAffairs_selectedYears");
//     return saved !== null ? JSON.parse(saved) : [getCurrentYear()];
//   };
//   const [filter, setFilter] = useState("all");
//   const [selectedMonths, setSelectedMonths] = useState(
//     getInitialSelectedMonths
//   );
//   const[skeltonloder,setSkeltonloader]=useState(false);
//   const [selectedYears, setSelectedYears] = useState(getInitialSelectedYears);
//   const [currentAffairsData, setCurrentAffairsData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [currentSkip, setCurrentSkip] = useState(8);
//   const [loader, setLoader] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [data, setData] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [listData, setListData] = useState(true);
//   const [newloader, setnewloader] = useState(true);
//   const skipRef = useRef(0);
//   const scrollRef = useRef(null);
//   const [isApiCallinProgress, setIsApiCallinProgress] = useState(false);
//   const [noDataForCurrentFilter, setNoDataForCurrentFilter] = useState(false);
//   const [currentFilterKey, setCurrentFilterKey] = useState("");
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [filterLoading, setFilterLoading] = useState(false);

//   const handleChange = (e) => {
//     setFilterLoading(true);
//     setFilter(e.target.value);
//   };



//   // Persist selection
//   useEffect(() => {
//     localStorage.setItem(
//       "currentAffairs_selectedMonths",
//       JSON.stringify(selectedMonths)
//     );
//   }, [selectedMonths]);

//   useEffect(() => {
//     localStorage.setItem(
//       "currentAffairs_selectedYears",
//       JSON.stringify(selectedYears)
//     );
//   }, [selectedYears]);

//   // Restore scroll position when data is loaded
//   useEffect(() => {
//     if (currentAffairsData.length > 0 && currentFilterKey && scrollRef.current) {
//       const scrollKey = `currentAffairs_${currentFilterKey}_scroll`;
//       const savedScrollPosition = localStorage.getItem(scrollKey);
//       if (savedScrollPosition) {
//         // Use setTimeout to ensure DOM is fully rendered
//         setTimeout(() => {
//           if (scrollRef.current) {
//             scrollRef.current.scrollTop = parseInt(savedScrollPosition, 10);
//           }
//         }, 100);
//       }
//     }
//   }, [currentAffairsData.length, currentFilterKey]);

//   // Show skeleton immediately when filter changes (but don't clear data)
//   useEffect(() => {
//     if (!isInitialLoad) {
//       setnewloader(true);
//       setListData(false);
//       // Don't clear currentAffairsData - let the main useEffect handle it
//     }
//   }, [filter]);

//   // Clear filter loading state when data is loaded
//   useEffect(() => {
//     setFilterLoading(false);
//   }, [currentAffairsData]);

//   // Fetch filter categories on mount and set default active "All"
//   useEffect(() => {
//     setListData(false);
//     setnewloader(true);
//     const fetchData = async () => {
//       setnewloader(true);
//       const result = await filterDatalist.filterData();
//       setData(result);

//       // Find index of saved filter or "All" filter, default to 0 if not found
//       const savedCategory =
//         localStorage.getItem("currentAffairs_selectedCategory") || "All";
//       const savedIndex = result.findIndex(
//         (cat) => cat.name.toLowerCase() === savedCategory.toLowerCase()
//       );
//       if (savedIndex !== -1) {
//         setActiveIndex(savedIndex);
//       } else {
//         const allIndex = result.findIndex(
//           (cat) => cat.name.toLowerCase() === "all"
//         );
//         if (allIndex !== -1) {
//           setActiveIndex(allIndex);
//         } else if (result.length > 0) {
//           setActiveIndex(0);
//         }
//       }
//     };
//     fetchData();
//   }, []);

//   // Infinite scroll listener with scroll position saving
//   useEffect(() => {
//     const div = scrollRef.current;
//     if (!div) return;

//     let timeoutId = null;
//     let scrollSaveTimeout = null;

//     const handleScroll = () => {
//       // Clear any pending timeout
//       if (timeoutId) {
//         clearTimeout(timeoutId);
//       }

//       // Save scroll position (debounced)
//       if (scrollSaveTimeout) {
//         clearTimeout(scrollSaveTimeout);
//       }
//       scrollSaveTimeout = setTimeout(() => {
//         if (currentFilterKey) {
//           const scrollKey = `currentAffairs_${currentFilterKey}_scroll`;
//           localStorage.setItem(scrollKey, div.scrollTop.toString());
//         }
//       }, 200); // 200ms debounce for saving scroll position

//       // Check for pagination (debounced)
//       timeoutId = setTimeout(() => {
//         if (
//           div.scrollTop + div.clientHeight + 80 >= div.scrollHeight &&
//           !loader &&
//           hasMore &&
//           !newloader &&
//           !isApiCallinProgress
//         ) {
//           setLoader(true);
//           setnewloader(true);
//           setPage((prevPage) => prevPage + 1);
//         }
//       }, 100); // 100ms debounce for pagination
//     };

//     div.addEventListener("scroll", handleScroll);
//     return () => {
//       div.removeEventListener("scroll", handleScroll);
//       if (timeoutId) {
//         clearTimeout(timeoutId);
//       }
//       if (scrollSaveTimeout) {
//         clearTimeout(scrollSaveTimeout);
//       }
//     };
//   }, [hasMore, currentFilterKey, loader, newloader, isApiCallinProgress]);

//   // Main data fetching effect
//   useEffect(() => {
  
//     let keywords =
//       selectedCategory === "All" ||
//       (Array.isArray(selectedCategory) && selectedCategory[0] === "All")
//         ? []
//         : Array.isArray(selectedCategory)
//         ? selectedCategory
//         : String(selectedCategory).split(/[\/&]/);
  
//     // Create a unique key for current filter combination including years, months, and filter
//     const yearsKey =
//       selectedYears.length > 0 ? selectedYears.sort().join("_") : "noYears";
//     const monthsKey =
//       selectedMonths.length > 0 ? selectedMonths.sort().join("_") : "noMonths";
//     const newFilterKey = `${keywords.join(
//       "_"
//     )}_${yearsKey}_${monthsKey}_${filter}`;
    
//     // Create a unique key for localStorage based on filters (including the filter dropdown)
//     const storageKey = `currentAffairs_${newFilterKey}`;
//     const pageStorageKey = `${storageKey}_page`;
//     console.log("Storage key being created:", storageKey);
  
//     // Load cached data from localStorage FIRST - always show cached data immediately
//     const cachedData = localStorage.getItem(storageKey);
//     const cachedPage = localStorage.getItem(pageStorageKey);
    
//     let existingData = [];
//     let loadedPage = 1;
    
//     if (cachedData) {
//       try {
//         existingData = JSON.parse(cachedData);
//         // Load the page number for this filter
//         if (cachedPage) {
//           loadedPage = parseInt(cachedPage, 10);
//         }
//       } catch (error) {
//         console.error("Error parsing cached data:", error);
//         // If parsing fails, remove invalid cache
//         localStorage.removeItem(storageKey);
//         localStorage.removeItem(pageStorageKey);
//         existingData = [];
//         loadedPage = 1;
//       }
//     }
  
//     // Check if filter changed - reset pagination if it did
//     if (newFilterKey !== currentFilterKey) {
//       setCurrentFilterKey(newFilterKey);
      
//       // Show cached data immediately for new filter
//       if (existingData.length > 0) {
//         setCurrentAffairsData(existingData);
//         setPage(loadedPage);
//         skipRef.current = existingData.length;
//         setNoDataForCurrentFilter(false);
//         setnewloader(false);
//         setListData(false);
//         setHasMore(true);
        
//         // Restore scroll position for this filter after data is rendered
//         setTimeout(() => {
//           const scrollKey = `currentAffairs_${newFilterKey}_scroll`;
//           const savedScrollPosition = localStorage.getItem(scrollKey);
//           if (savedScrollPosition && scrollRef.current) {
//             scrollRef.current.scrollTop = parseInt(savedScrollPosition, 10);
//           }
//         }, 0);
        
//         return; // Don't make API call, just show cached data
//       } else {
//         // No cached data, show skeleton and fetch from API
//         setCurrentAffairsData([]);
//         setPage(1);
//         skipRef.current = 0;
//         setNoDataForCurrentFilter(false);
//         setnewloader(true);
//         setListData(false);
//         setHasMore(true);
        
//         // Reset scroll position for new filter with no cache
//         if (scrollRef.current) {
//           scrollRef.current.scrollTop = 0;
//         }
//       }
//     }
  
//     // If we have cached data, show it first before making API call
//     if (existingData.length > 0 && currentAffairsData.length === 0) {
//       setCurrentAffairsData(existingData);
//       setListData(false);
//     }
  
//     // If we already know there's no data for this filter combination, don't make the API call
//     if (noDataForCurrentFilter && newFilterKey === currentFilterKey) {
//       setLoader(false);
//       setnewloader(false);
//       setListData(true);
//       return;
//     }
  
//     // Check if we should make an API call
//     // Only make API call if:
//     // 1. Not already in progress
//     // 2. We're on a new page OR it's a new filter with no cached data
//     const shouldMakeApiCall = 
//       !isApiCallinProgress && 
//       (page > loadedPage || (page === 1 && existingData.length === 0));
  
//     if (!shouldMakeApiCall) {
//       setnewloader(false);
//       setLoader(false);
//       return;
//     }
  
//     // Get current date
//     let currentDate = new Date().toDateString();
  
//     // Make API call - show skeleton only at the bottom if we have existing data
//     if (existingData.length > 0) {
//       setLoader(true); // Show loader at bottom for pagination
//     } else {
//       setnewloader(true); // Show skeleton for initial load
//     }
    
//     setIsApiCallinProgress(true);
//         setSkeltonloader(true)
//     fetchFilterData(
//       skipRef.current,
//       filter,
//       keywords,
//       selectedYears,
//       selectedMonths
//     )
//       .then((response) => {

//         console.log("response", response);
//         console.log(newloader,"newloader");
//         if (!response.items || response.items.length === 0) {
//           setListData(existingData.length === 0); // Only show "no data" if we have no cached data
//           setNoDataForCurrentFilter(existingData.length === 0);
//           setHasMore(false);
//         } else {
//           // Simply append new data without duplicate checking
//           const newData = [...existingData, ...response.items];

//           setCurrentAffairsData(newData);

//           // Update cache with the combined data
//           localStorage.setItem(storageKey, JSON.stringify(newData));
//           localStorage.setItem(`${storageKey}_date`, currentDate);
          
//           // Store the current page number (we've just loaded this page)
//           localStorage.setItem(pageStorageKey, page.toString());

//           skipRef.current = newData.length;
//           setCurrentSkip(newData.length);
//           setHasMore(response.items.length > 0);
//           setListData(false);
//         }
//       })
//       .catch((e) => {
//         console.error("API failed", e);
//         setHasMore(false);
//         setListData(existingData.length === 0);
//       })
//       .finally(() => {
//         setIsLoading(false);
//         setLoader(false);
//         setnewloader(false);
//         setIsApiCallinProgress(false);
//             setSkeltonloader(false)
//       });
//   }, [page, filter, selectedCategory, calender, selectedYears, selectedMonths]);
  
//   // ...existing code...

//   useEffect(() => {
//     localStorage.setItem(
//       "selectedCategory",
//       JSON.stringify(selectedCategory === "All" ? "" : selectedCategory)
//     );
//     localStorage.setItem("selectedYears", JSON.stringify(selectedYears));
//     localStorage.setItem("selectedMonths", JSON.stringify(selectedMonths));
//   }, [selectedCategory, selectedYears, selectedMonths]);

//   // When selectedCategory or calender changes, update activeIndex
//   useEffect(() => {
//     if (!isInitialLoad) {
//       // Don't reset page here - let the main useEffect handle filter changes
//       const newIndex = data.findIndex((cat) => cat.name === selectedCategory);
//       if (newIndex !== -1) {
//         setActiveIndex(newIndex);
//       }
//     } else {
//       setIsInitialLoad(false);
//     }
//   }, [
//     selectedCategory,
//     calender,
//     selectedYears,
//     selectedMonths,
//     data,
//     isInitialLoad,
//   ]);

//   const handleClick = (categoryName) => {
//     setSelectedCategory(categoryName);
//     // Save selected category to localStorage
//     localStorage.setItem("currentAffairs_selectedCategory", categoryName);
//   };

//   const filterDivRef = useRef();

//   const handleScrollleft = () => {
//     if (filterDivRef.current) {
//       filterDivRef.current.scrollBy({ left: 100, behavior: "smooth" });
//     }
//   };

//   const handleScrollright = () => {
//     if (filterDivRef.current) {
//       filterDivRef.current.scrollBy({ left: -100, behavior: "smooth" });
//     }
//   };

//   console.log("Current filter values:", {
//     selectedMonths,
//     selectedYears,
//     calender,
//     keywords:
//       selectedCategory === "All" ||
//       (Array.isArray(selectedCategory) && selectedCategory[0] === "All")
//         ? []
//         : Array.isArray(selectedCategory)
//         ? selectedCategory
//         : String(selectedCategory).split(/[\/&]/),
//   });

//   return (
//     <div className="main-div">
//       <div
//         className="syllabus-header-main"
//         style={
//           isSidebarColl
//             ? { left: 0, width: "100%" }
//             : { left: "240px", width: "calc(100% - 240px)" }
//         }
//       >
//         <Header
//           message={[{ message: "Current Affairs" }]}
//           Check={Check}
//           isSidebarColl={isSidebarColl}
//         />
//       </div>
//       {isLoading ? (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       ) : isLoading && currentAffairsData.length === 0 ? (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       ) : (
//         <div className="current-affairsdiv" ref={scrollRef}>
//           <div className="imgdiv">
//             <img
//               className="d-none d-md-block dekstop-img"
//               src="/assets/images/banner_currentaffairs.svg"
//               alt="star"
//             />
//             <img
//               className="d-block d-md-none custo"
//               src="/assets/images/mobile-view-landingpage.svg"
//               alt="star"
//             />
//           </div>

//           <div style={{ display: "flex" }} className="fil">
//             <div>
//               <button
//                 className="filter-button-arrow-right"
//                 onClick={handleScrollright}
//               >
//                 <img
//                   src="/assets/images/arrow2.svg"
//                   className="img-arrow"
//                   style={{ marginLeft: "0px" }}
//                 />
//               </button>
//             </div>

//             <div className="filter-div" ref={filterDivRef}>
//               {data.map((category, index) => (
//                 <button
//                   key={index}
//                   className={`filter-button ${
//                     activeIndex === index ? "active" : ""
//                   }`}
//                   onClick={() => {
                    
//                       // prevent click when loading
//                       handleClick(category.name);
//                       setActiveIndex(index);
                    
//                   }}
//                   disabled={newloader}
//                 >
//                   <img src={category.img} alt="icon" />
//                   <span className="filt-text">{category.name}</span>
//                 </button>
//               ))}
//             </div>

//             <div>
//               <button
//                 className="filter-button-arrow"
//                 onClick={handleScrollleft}
//               >
//                 <img
//                   src="/assets/images/arrow2.svg"
//                   className="img-arrow"
//                   style={{ marginLeft: "0px" }}
//                 />
//               </button>
//             </div>
//           </div>

//           <div className="heading-current-affairs">
//             {/* <div className="text-heading-current-affairs">
//               <img src="assets/images/world-icon.svg" />
//               <span className="text-Curated">Curated for you</span>
//             </div> */}
//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 alignItems: "end",
//                 justifyItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <Calender
//                 setCalender={setCalender}
//                 calender={calender}
//                 setSelectedYears={setSelectedYears}
//                 setSelectedMonths={setSelectedMonths}
//                 selectedYears={selectedYears}
//                 selectedMonths={selectedMonths}
//                 newloader={newloader}
//               />
//               <div>
//                 <select
//                  className="filt-text"
//                   id="filter"
//                   value={filter}
//                   onChange={handleChange}
//                   disabled={newloader}
//                   style={{
//                     border: "1px solid #e6e6e6",
//                     padding: "10px",
//                     backgroundColor: newloader ? "#f5f5f5" : "#f0f0f0",
//                     width: "80px",
//                     height: "28px",
//                     padding: "5px",
//                     borderRadius: "4px",
//                     color: "#333",
//                     opacity: newloader ? 0.7 : 1,
//                   }}
//                 >
//                   <option className="filt-text" value="all">All</option>
//                   <option className="filt-text" value="read">Read</option>
//                   <option className="filt-text" value="unread">Unread</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="parent-div">
//             {currentAffairsData &&
//               currentAffairsData.map((item, index) => (
//                 <CurrentAffairsLandipageCards
//                   key={index}
//                   news={item}
//                   setIsLoading={setIsLoading}
//                 />
//               ))}

//             {/* Single skeleton loader only */}
//             {(skeltonloder) && (
//               <div style={{ marginBottom: "20px" }}>
//                 <Skeleton height={100} style={{ marginBottom: "15px" }} />
//                 <Skeleton height={40} style={{ marginBottom: "15px" }} />
//                 <Skeleton count={3} />
//               </div>
//             )}

//             {listData &&
//               !newloader &&
//               !loader &&
//               currentAffairsData.length === 0 && (
//                 <div className="no-data">
//                   <img
//                     src="/assets/images/no-data-currentaffairs.png"
//                     className="no-data-img"
//                     width={40}
//                     height={40}
//                   />{" "}
//                   <h3>No Data Found</h3>
//                 </div>
//               )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CurrentAffairsLandingPage;


import React, { useEffect, useRef, useState } from "react";
import CurrentAffairsLandipageCards from "./CurrentAffairsLandipageCards";
import Calender from "./LandingCalender";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import filterDatalist from "../services/getFilter";
import "../CurrentAffairsLandipageCards.css";
import {
  fetchFilterData,
  fetchCurrentAffairById,
} from "../services/trendingService";
import { getRelatedTopicsTen } from "../services/relatedTopicsService";

const getPendingRestore = () => {
  try {
    const saved = sessionStorage.getItem("currentAffairs_pendingRestore");
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

function CurrentAffairsLandingPage({ Check, isSidebarColl }) {
  // Initialize selectedCategory from localStorage or default to "All"
  const getInitialSelectedCategory = () => {
    const savedCategory = localStorage.getItem(
      "currentAffairs_selectedCategory"
    );
    return savedCategory || "All";
  };

  const [selectedCategory, setSelectedCategory] = useState(
    getInitialSelectedCategory
  );
  const [calender, setCalender] = useState("all");

  // Helper to get current month and year
  const getCurrentYear = () => new Date().getFullYear();
  const getCurrentMonth = () => {
    const months = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    return months[new Date().getMonth()];
  };

  // Load from localStorage or use current
  const getInitialSelectedMonths = () => {
    const saved = localStorage.getItem("currentAffairs_selectedMonths");
    return saved !== null ? JSON.parse(saved) : [getCurrentMonth()];
  };
  const getInitialSelectedYears = () => {
    const saved = localStorage.getItem("currentAffairs_selectedYears");
    return saved !== null ? JSON.parse(saved) : [getCurrentYear()];
  };
  const [filter, setFilter] = useState("all");
  const [selectedMonths, setSelectedMonths] = useState(
    getInitialSelectedMonths
  );
  const [selectedYears, setSelectedYears] = useState(getInitialSelectedYears);
  const pendingRestore = getPendingRestore();
  const restoreListRef = useRef(
    Array.isArray(pendingRestore?.articles) && pendingRestore.articles.length > 0
  );
  const [currentAffairsData, setCurrentAffairsData] = useState(
    () =>
      restoreListRef.current
        ? pendingRestore.allArticles && pendingRestore.allArticles.length > 0
          ? pendingRestore.allArticles
          : pendingRestore.articles
        : []
  );
  const [page, setPage] = useState(
    () => restoreListRef.current ? pendingRestore.page || 1 : 1
  );
  const [currentSkip, setCurrentSkip] = useState(8);
  const [loader, setLoader] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [listData, setListData] = useState(true);
  const [newloader, setnewloader] = useState(false);
  const skipRef = useRef(restoreListRef.current ? pendingRestore.skip || 0 : 0);
  const scrollRef = useRef(null);
  const restoredArticleRef = useRef(false);
  const [isApiCallinProgress, setIsApiCallinProgress] = useState(false);
  const [noDataForCurrentFilter, setNoDataForCurrentFilter] = useState(false);
  const [currentFilterKey, setCurrentFilterKey] = useState("");
  const filterStateInitializedRef = useRef(false);
  const previousFilterRef = useRef(filter);
  const [isLoading, setIsLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(
    () => (restoreListRef.current ? pendingRestore.searchTerm || "" : "")
  );
  const [searchResults, setSearchResults] = useState(
    () =>
      restoreListRef.current && pendingRestore.searchTerm
        ? pendingRestore.articles || null
        : null
  );
  const [isSearching, setIsSearching] = useState(false);

  // Debounce search effect
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.trim()) {
        performSearch(searchTerm.trim());
      } else {
        setSearchResults(null);
        setIsSearching(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const performSearch = async (term) => {
    setIsSearching(true);
    setnewloader(true);
    setListData(false);
    try {
      const response = await getRelatedTopicsTen([term]);
      // Assuming response.matches or response.items contains the items
      setSearchResults(response.matches || response.items || []);
    } catch (error) {
      console.error("Search failed:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
      setnewloader(false);
      setListData(true);
    }
  };


  // Persist selection
  useEffect(() => {
    localStorage.setItem(
      "currentAffairs_selectedMonths",
      JSON.stringify(selectedMonths)
    );
  }, [selectedMonths]);

  useEffect(() => {
    localStorage.setItem(
      "currentAffairs_selectedYears",
      JSON.stringify(selectedYears)
    );
  }, [selectedYears]);

  // Show skeleton immediately when filter changes
  useEffect(() => {
    if (previousFilterRef.current === filter) return;
    previousFilterRef.current = filter;
    setnewloader(true);
    setListData(false);
    setCurrentAffairsData([]); // Clear existing data to show skeleton
  }, [filter]);

  // Clear filter loading state when data is loaded
  useEffect(() => {
    setFilterLoading(false);
  }, [currentAffairsData]);

  // Restore the article's position after returning from its detail page. The
  // article ID is more reliable than a raw scroll offset when new articles
  // have been inserted since the previous visit.
  useEffect(() => {
    if (
      restoredArticleRef.current ||
      currentAffairsData.length === 0 ||
      !scrollRef.current
    ) {
      return;
    }

    const savedPosition = sessionStorage.getItem(
      "currentAffairs_pendingRestore"
    );
    if (!savedPosition) return;

    let pendingRestore;
    try {
      pendingRestore = JSON.parse(savedPosition);
    } catch {
      sessionStorage.removeItem("currentAffairs_pendingRestore");
      return;
    }

    let attempts = 0;
    let retryTimer;

    const restoreArticle = () => {
      const container = scrollRef.current;
      const articleCard = container &&
        Array.from(
          container.querySelectorAll("[data-current-affair-id]")
        ).find(
          (element) =>
            element.dataset.currentAffairId === pendingRestore.articleId
        );

      // Allow the API response and card layout a short time to finish before
      // giving up. This also handles cached data being replaced by fresh data.
      if (!container || !articleCard) {
        attempts += 1;
        if (attempts < 20) {
          retryTimer = setTimeout(restoreArticle, 100);
        }
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const cardRect = articleCard.getBoundingClientRect();
      const relativeTop = Number.isFinite(pendingRestore.relativeTop)
        ? pendingRestore.relativeTop
        : 0;

      container.scrollTop += cardRect.top - containerRect.top - relativeTop;
      restoredArticleRef.current = true;
      sessionStorage.removeItem("currentAffairs_pendingRestore");
    };

    restoreArticle();
    return () => clearTimeout(retryTimer);
  }, [currentAffairsData]);

  // Fetch filter categories on mount and set default active "All"
  useEffect(() => {
    setListData(false);
    setnewloader(true);
    const fetchData = async () => {
      setnewloader(true);
      const result = await filterDatalist.filterData();
      setData(result);

      // Find index of saved filter or "All" filter, default to 0 if not found
      const savedCategory =
        localStorage.getItem("currentAffairs_selectedCategory") || "All";
      const savedIndex = result.findIndex(
        (cat) => cat.name.toLowerCase() === savedCategory.toLowerCase()
      );
      if (savedIndex !== -1) {
        setActiveIndex(savedIndex);
      } else {
        const allIndex = result.findIndex(
          (cat) => cat.name.toLowerCase() === "all"
        );
        if (allIndex !== -1) {
          setActiveIndex(allIndex);
        } else if (result.length > 0) {
          setActiveIndex(0);
        }
      }
    };
    fetchData();
  }, []);

  // Infinite scroll listener
  useEffect(() => {
    const div = scrollRef.current;
    if (!div) return;

    let timeoutId = null;

    const loadMoreData = () => {
      // Clear any pending timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Debounce the scroll event
      timeoutId = setTimeout(() => {
        // Don't paginate when searching - only when showing cached/filtered data
        if (
          div.scrollTop + div.clientHeight + 80 >= div.scrollHeight &&
          !loader &&
          hasMore &&
          !newloader &&
          !isApiCallinProgress &&
          !isSearching && // Disable pagination during search
          !searchTerm.trim() // Disable pagination when search term exists
        ) {
          setLoader(true);
          setnewloader(true);
          setPage((prevPage) => prevPage + 1);
        }
      }, 100); // 100ms debounce
    };

    div.addEventListener("scroll", loadMoreData);
    return () => {
      div.removeEventListener("scroll", loadMoreData);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [hasMore, isSearching, searchTerm]);

  // Main data fetching effect
  useEffect(() => {
    // Always show skeleton at the start of any API call
    setnewloader(true);
    setListData(false);
    setHasMore(true);

    // A back navigation can restore more than the first API page. Keep that
    // list intact and let the next user scroll continue from its saved skip.
    if (restoreListRef.current) {
      restoreListRef.current = false;
      setHasMore(pendingRestore?.hasMore ?? true);
      setCurrentSkip(skipRef.current);
      setListData(currentAffairsData.length === 0);
      setnewloader(false);
      setLoader(false);
      return;
    }

    let keywords =
      selectedCategory === "All" ||
      (Array.isArray(selectedCategory) && selectedCategory[0] === "All")
        ? []
        : Array.isArray(selectedCategory)
        ? selectedCategory
        : String(selectedCategory).split(/[\/&]/);

    if (page === 1) {
      setCurrentAffairsData([]);
      skipRef.current = 0;
      setHasMore(true);
      setNoDataForCurrentFilter(false);
    }

    // Create a unique key for current filter combination including years, months, and filter
    const yearsKey =
      selectedYears.length > 0 ? selectedYears.sort().join("_") : "noYears";
    const monthsKey =
      selectedMonths.length > 0 ? selectedMonths.sort().join("_") : "noMonths";
    const newFilterKey = `${keywords.join(
      "_"
    )}_${yearsKey}_${monthsKey}_${filter}`;
    setCurrentFilterKey(newFilterKey);

    // If we already know there's no data for this filter combination, don't make the API call
    if (noDataForCurrentFilter && newFilterKey === currentFilterKey) {
      setLoader(false);
      setnewloader(false);
      setListData(true);
      return;
    }

    // Create a unique key for localStorage based on filters (including the filter dropdown)
    const storageKey = `currentAffairs_${newFilterKey}`;

    // Get current date
    let currentDate = new Date().toDateString();

    const cachedData = localStorage.getItem(storageKey);
    const cachedDate = localStorage.getItem(`${storageKey}_date`);

    // If we have cached data for today, still make API call to get latest data
    if (cachedData && cachedDate === currentDate && page === 1) {
      try {
        const parsedData = JSON.parse(cachedData);
        // Show cached data immediately for better UX
        setCurrentAffairsData(parsedData);
        setHasMore(parsedData.length > 0);
        setLoader(false);
        setnewloader(false);
        setListData(parsedData.length === 0);

        // Reset skip for fresh API call
        skipRef.current = 0;
        setCurrentSkip(0);

        // Continue with API call to update data
      } catch (error) {
        console.error("Error parsing cached data:", error);
        // If parsing fails, remove invalid cache
        localStorage.removeItem(storageKey);
        localStorage.removeItem(`${storageKey}_date`);
      }
    } else if (cachedDate !== currentDate) {
      // Clear old cache
      localStorage.removeItem(storageKey);
      localStorage.removeItem(`${storageKey}_date`);
    }

    // Make API call if not already in progress
    if (!isApiCallinProgress) {
      setnewloader(true); // Ensure skeleton is shown
      setIsApiCallinProgress(true);

      fetchFilterData(
        skipRef.current,
        filter,
        keywords,
        selectedYears,
        selectedMonths
      )
        .then((response) => {
          setHasMore(true);
          setnewloader(false);
          if (!response.items || response.items.length === 0) {
            setListData(true);
            setNoDataForCurrentFilter(true); // Mark that we have no data for this filter combination
            // setCurrentAffairsData([]);
          } else {
            let newData;
            if (page === 1) {
              newData = response.items;
              // Always update cache with latest data
              localStorage.setItem(storageKey, JSON.stringify(response.items));
              localStorage.setItem(`${storageKey}_date`, currentDate);
            } else {
              setCurrentAffairsData((prevData) => {
                const existingData = prevData || [];
                const combinedData = [...existingData, ...response.items];

                // Filter to ensure only unique IDs
                const uniqueData = combinedData.filter(
                  (item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id)
                );

                return uniqueData;
              });

              skipRef.current += response.items.length;
              setCurrentSkip(skipRef.current);
              setHasMore(response.items.length > 0);
              setLoader(false);
              setnewloader(false);

              return;
            }

            // Filter to ensure only unique IDs for page 1
            const uniqueData = newData.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
            );

            setCurrentAffairsData(uniqueData);
            skipRef.current += response.items.length;
            setCurrentSkip(skipRef.current);
            setHasMore(response.items.length > 0);
            setListData(uniqueData.length === 0);
          }
        })
        .catch((e) => {
          console.error("API failed", e);
          setHasMore(false);
          setnewloader(false);
          setListData(true);
        })
        .finally(() => {
          setLoader(false);
          setnewloader(false);
          setIsApiCallinProgress(false);
        });
    }
  }, [page, filter, selectedCategory, selectedYears, selectedMonths]);

  useEffect(() => {
    localStorage.setItem(
      "selectedCategory",
      JSON.stringify(selectedCategory === "All" ? "" : selectedCategory)
    );
    localStorage.setItem("selectedYears", JSON.stringify(selectedYears));
    localStorage.setItem("selectedMonths", JSON.stringify(selectedMonths));
  }, [selectedCategory, selectedYears, selectedMonths]);

  // When selectedCategory or calender changes, reset page and update activeIndex
  useEffect(() => {
    if (!filterStateInitializedRef.current) {
      filterStateInitializedRef.current = true;
      return;
    }

    setPage(1);
    const newIndex = data.findIndex((cat) => cat.name === selectedCategory);
    if (newIndex !== -1) {
      setActiveIndex(newIndex);
    }
  }, [
    selectedCategory,
    selectedYears,
    selectedMonths,
  ]);

  const handleClick = (categoryName) => {
    setSelectedCategory(categoryName);
    // Save selected category to localStorage
    localStorage.setItem("currentAffairs_selectedCategory", categoryName);
  };

  const filterDivRef = useRef();

  const handleScrollleft = () => {
    if (filterDivRef.current) {
      filterDivRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const handleScrollright = () => {
    if (filterDivRef.current) {
      filterDivRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };


  return (
    <div className="main-div">
      {isLoading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : loader && currentAffairsData.length === 0 ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="current-affairsdiv" ref={scrollRef}>
          <div className="imgdiv">
            <img
              className="d-none d-md-block dekstop-img"
              src="/assets/images/banner_currentaffairs.svg"
              alt="star"
            />
            <img
              className="d-block d-md-none custo"
              src="/assets/images/mobile-view-landingpage.svg"
              alt="star"
            />
          </div>

          {/* <div style={{ display: "flex" }} className="fil">
            <div>
              <button
                className="filter-button-arrow-right"
                onClick={handleScrollright}
              >
                <img
                  src="/assets/images/arrow2.svg"
                  className="img-arrow"
                  style={{ marginLeft: "0px" }}
                />
              </button>
            </div>

            <div className="filter-div" ref={filterDivRef}>
              {data.map((category, index) => (
                <button
                  key={index}
                  className={`filter-button ${
                    activeIndex === index ? "active" : ""
                  }`}
                  onClick={() => {
                    
                      // prevent click when loading
                      handleClick(category.name);
                      setActiveIndex(index);
                    
                  }}
                  disabled={newloader}
                >
                  <img src={category.img} alt="icon" />
                  <span className="filt-text">{category.name}</span>
                </button>
              ))}
            </div>

            <div>
              <button
                className="filter-button-arrow"
                onClick={handleScrollleft}
              >
                <img
                  src="/assets/images/arrow2.svg"
                  className="img-arrow"
                  style={{ marginLeft: "0px" }}
                />
              </button>
            </div>
          </div> */}

          <div className="heading-current-affairs">
            {/* <div className="text-heading-current-affairs">
              <img src="assets/images/world-icon.svg" />
              <span className="text-Curated">Curated for you</span>
            </div> */}
            <label className="ca-search">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
              </svg>
              <input
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search topics..."
                aria-label="Search topics"
              />
            </label>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "end",
                justifyItems: "center",
                justifyContent: "center",
              }}
            >
              <Calender
                setCalender={setCalender}
                calender={calender}
                setSelectedYears={setSelectedYears}
                setSelectedMonths={setSelectedMonths}
                selectedYears={selectedYears}
                selectedMonths={selectedMonths}
                newloader={newloader || isSearching}
                scrollContainerRef={scrollRef}
                filter={filter}
                setFilter={setFilter}
                setFilterLoading={setFilterLoading}
                categories={data}
                activeKeyword={selectedCategory === 'All' ? '' : selectedCategory}
                activeIndex={activeIndex}
                setActiveKeyword={(kw) => {
                  const cat = kw || 'All';
                  setSelectedCategory(cat);
                  localStorage.setItem("currentAffairs_selectedCategory", cat);
                }}
                setActiveIndex={setActiveIndex}
              />
            </div>
          </div>

          <div className="parent-div">
            {(searchTerm.trim() ? searchResults : currentAffairsData) &&
              (searchTerm.trim() ? searchResults : currentAffairsData).map(
                (item, index) => (
                  <CurrentAffairsLandipageCards
                    key={item.id}
                    news={item}
                    setIsLoading={setIsLoading}
                    loadedArticles={searchTerm.trim() ? searchResults : currentAffairsData}
                    loadedPage={page}
                    loadedSkip={skipRef.current}
                    loadedHasMore={hasMore}
                    searchTerm={searchTerm}
                    allArticles={currentAffairsData}
                  />
                )
              )}

            {/* Single skeleton loader only */}
            {(newloader || loader) && (
              <div style={{ marginBottom: "20px" }}>
                <Skeleton height={100} style={{ marginBottom: "15px" }} />
                <Skeleton height={40} style={{ marginBottom: "15px" }} />
                <Skeleton count={3} />
              </div>
            )}

            {listData &&
              !newloader &&
              !loader &&
              !isSearching &&
              (searchTerm.trim()
                ? searchResults?.length === 0
                : currentAffairsData.length === 0) && (
                <div className="no-data">
                  <img
                    src="/assets/images/no-data-currentaffairs.png"
                    className="no-data-img"
                    width={40}
                    height={40}
                  />{" "}
                  <h3>No articles found</h3>
                </div>
              )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CurrentAffairsLandingPage;
